import { useSelector } from 'react-redux'
import { config } from '../config'
import { valueHolderActionCreator } from '../shared/redux/actions/common'
import { SET_TENANT_FILTER } from '../redux/const'

/*
 * Globalny filter tenanta v admine (prepinac v hornej liste, len pre superadmina = admin hlavneho tenanta).
 * Plati pre Locations, Users, Tags, Pricing conditions, Schedules a Charging history.
 * Na Hubject, Dashboard a Logs sa neuplatnuje (prepinac je tam neaktivny).
 * Vyber sa pamata v prehliadaci (localStorage) aj po obnoveni stranky.
 */

const STORAGE_KEY = 'admin.tenantFilter'

// stranky (cesty z AppRouter), na ktore sa filter tenanta neuplatnuje
export const TENANT_FILTER_UNSUPPORTED_PATHS = ['/hubject', '/dashboard', '/logs']

export const loadSavedTenantFilter = (): string | null => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || null
    } catch {
        return null
    }
}

export const setTenantFilter = (tenantId: string | null) => {
    try {
        if (tenantId) {
            window.localStorage.setItem(STORAGE_KEY, tenantId)
        } else {
            window.localStorage.removeItem(STORAGE_KEY)
        }
    } catch {
        // localStorage nedostupny (napr. sukromne okno) - filter plati aspon do obnovenia stranky
    }
    return valueHolderActionCreator(SET_TENANT_FILTER, tenantId)
}

export const useIsSuperAdmin = (): boolean => {
    const loginTenantId = useSelector((state: any) => state.login.value?.user?.tenantId)
    return Boolean(loginTenantId) && loginTenantId === config.mainTenantId
}

/**
 * Aktivny filter tenanta (tenantId) alebo null = vsetci tenanti.
 * Pre ostatnych adminov vzdy null - ich data obmedzuje backend podla prihlasenia.
 */
export const useTenantFilter = (): string | null => {
    const isSuperAdmin = useIsSuperAdmin()
    const value = useSelector((state: any) => state.tenantFilter?.value)
    // hlavny tenant (superadmin) znamena "vsetci tenanti" (napr. stara hodnota v localStorage)
    return isSuperAdmin && value && value !== config.mainTenantId ? value : null
}

/**
 * Patri zaznam (lokalita, tag, cennik, rozvrh) do vybraneho tenanta?
 * Zaznam bez tenanta (tenantId = null) sa povazuje za zaznam hlavneho tenanta.
 */
export const matchesTenantFilter = (entityTenantId: string | null | undefined, tenantFilter: string | null): boolean => {
    if (!tenantFilter) return true
    if (!entityTenantId) return tenantFilter === config.mainTenantId
    return entityTenantId.toLowerCase() === tenantFilter.toLowerCase()
}

/**
 * Patri pouzivatel do vybraneho tenanta? Pouzivatel moze mat viac tenantov (ciarkou oddeleny zoznam Tenants)
 * - rovnaka logika ako backend (UserService.FilterUsersByTenantId).
 */
export const userMatchesTenantFilter = (userTenants: string | null | undefined, tenantFilter: string | null): boolean => {
    if (!tenantFilter) return true
    return (userTenants ?? '')
        .split(',')
        .map((x) => x.trim().toLowerCase())
        .includes(tenantFilter.toLowerCase())
}
